import React, { useEffect, useState, useRef } from "react";
import moment from 'moment';
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import ProjectService from "../services/ProjectService";
import ProjectCategoryService from "../services/ProjectCategoryService";
import ItemCategoryService from "../services/ItemCategoryService";
import ContractorService from "../services/ContractorService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import ProjectWorkItemsService from "../services/ProjectWorkItemsService";
import WorkItemService from "./../services/workitemService";
import UomService from "./../services/UomService";
import MessageDialog from "../components/MessageDialog";


export default function AddProject() {
  const navigate = useNavigate();
  // const messageTimer = useRef(null);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",   // 🔥 enables live validation
    defaultValues: {
      totalChainage: 0,
    },
  });

  const [projectCategories, setProjectCategories] = useState([]);
  const [itemCategories, setItemCategories] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [editLoading, setEditLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const [editLoading, setEditLoading] = useState(false);
  const [totalChainage, setTotalChainage] = useState(0);
  const { id } = useParams();

  const fromKMS = watch("fromKMS");
  const toKMS = watch("toKMS");
  const selectedCategoryId = watch("projectCategoryId");

  const [projectStartDate, setFromDate] = useState('');
  const [projectEndDate, setToDate] = useState('');
  const [error, setError] = useState(null);


  const [workItemsList, setWorkItemsList] = useState([]);
  const [uoms, setUoms] = useState([]);

  const filteredWorkItemsList = selectedCategoryId
    ? workItemsList.filter(
        (w) => String(w.projectCategoryId || w.project_category_id) === String(selectedCategoryId)
      )
    : [];

  useEffect(() => {
    if (!selectedCategoryId) {
      setProjectWorkItems((prev) =>
        prev.map((item) => ({ ...item, workItemId: "" }))
      );
    } else {
      setProjectWorkItems((prev) =>
        prev.map((item) => {
          if (!item.workItemId) return item;
          const match = workItemsList.some(
            (w) =>
              String(w.id) === String(item.workItemId) &&
              String(w.projectCategoryId || w.project_category_id) === String(selectedCategoryId)
          );
          return match ? item : { ...item, workItemId: "" };
        })
      );
    }
  }, [selectedCategoryId, workItemsList]);

  const [projectWorkItems, setProjectWorkItems] = useState([
    {
      slNo: "1",
      workItemId: "",
      // uom: "",
      quantity: "",
      isDashboard: false,
      isActive: true
    }
  ]);

  const validateDates = () => {
    if (!projectEndDate) {
      setError(null);
      return;
    }

    if (moment(projectEndDate).isSameOrBefore(projectStartDate)) {
      setError("End date must be grater than Start date");
    } else {
      setError(null);
    }
  };

  const renumberSlNos = (items) => {
    return items.map((item, index) => ({
      ...item,
      slNo: String(index + 1),
    }));
  };

  // const handleAddRow = () => {
  //   setProjectWorkItems([
  //     ...projectWorkItems,
  //     {
  //       slNo: "",
  //       workItemId: "",
  //       uom: "",
  //       quantity: "",
  //       isDashboard: false,
  //       isActive: true
  //     }
  //   ]);
  // };


  const handleAddRow = () => {
    const updated = [
      ...projectWorkItems,
      {
        slNo: String(projectWorkItems.length + 1),
        workItemId: "",
        uom: "",
        quantity: "",
        isDashboard: false,
        isActive: true,
      },
    ];

    setProjectWorkItems(updated);
  };


  // const handleDeleteRow = (index) => {
  //   const updated = [...projectWorkItems];
  //   updated.splice(index, 1);
  //   setProjectWorkItems(updated);
  // };

  const handleDeleteRow = (index) => {
    const updated = projectWorkItems.filter((_, i) => i !== index);

    setProjectWorkItems(renumberSlNos(updated));
  };

  const handleWorkItemChange = (index, field, value) => {
    const updated = [...projectWorkItems];
    updated[index][field] = value;
    setProjectWorkItems(updated);
  };

  // function getTodayDate() {
  //   const today = new Date();
  //   return today.toISOString().slice(0, 10);
  // }

  // const [date, setDate] = useState(getTodayDate());

  // useEffect(() => {
  //   const f = parseFloat(fromKMS) || 0;
  //   const t = parseFloat(toKMS) || 0;
  //   const total = t - f > 0 ? t - f : 0;

  //   setTotalChainage(total);
  //   setValue("totalChainage", total);
  // }, [fromKMS, toKMS, setValue]);



  useEffect(() => {
    const loadDropdowns = async () => {
      try {

        const workItemsRes = await WorkItemService.getActive();
        console.log("Work Items API:", workItemsRes);

        // setWorkItemsList(workItemsRes.data || workItemsRes || []);
        setWorkItemsList(workItemsRes.data || []);

        // setWorkItemsList(workItemsRes?.data?.data || []);

        const uomRes = await UomService.getActive();
        console.log("UOM API:", uomRes);

        setUoms(uomRes.data || uomRes || []);

      } catch (err) {
        console.error("Dropdown load error:", err);
      }
    };

    loadDropdowns();
  }, []);


  useEffect(() => {
    const f = parseFloat(fromKMS) || 0;
    const t = parseFloat(toKMS) || 0;

    let total = t - f > 0 ? t - f : 0;

    total = parseFloat(total).toFixed(3); // ✅ always 3 decimals

    setTotalChainage(total);
    setValue("totalChainage", total);
  }, [fromKMS, toKMS, setValue]);

  useEffect(() => {
    if (!id) {
      setValue(
        "projectStartDate",
        new Date().toISOString().split("T")[0]
      );
    }
  }, [id, setValue]);


  // useEffect(() => {
  //   if (!editMode) {
  //     const today = new Date().toISOString().split("T")[0];
  //     setValue("projectStartDate", today);
  //   }
  // }, [editMode, setValue]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [pcats, icats, conts] = await Promise.all([
          ProjectCategoryService.getActive(),
          ItemCategoryService.getActive(),
          ContractorService.getActive(),
        ]);

        setProjectCategories(pcats?.data || pcats || []);
        setItemCategories(icats?.data || icats || []);
        setContractors(conts?.data || conts || []);
      } catch (err) {
        console.error("Fetch dropdowns error:", err);
      }
    };

    fetchAll();
  }, []);

  /*  AUTO CODE PREFIX ON CATEGORY CHANGE */
  useEffect(() => {
    if (!selectedCategoryId || id) return;

    const category = projectCategories.find(
      (c) => String(c.id) === String(selectedCategoryId)
    );

    const prefix =
      category?.categoryCode ||
      category?.projectCategoryCode ||
      category?.code ||
      "";

    if (prefix && prefix.trim()) {
      const firstLetter = prefix.trim().charAt(0).toUpperCase();
      setValue("projectCode", `${firstLetter}-`);
    }
  }, [id, selectedCategoryId, projectCategories, setValue]);

  useEffect(() => {
    const loadEdit = async () => {
      if (!id) return;

      try {
        if (
          projectCategories.length === 0 ||
          itemCategories.length === 0 ||
          contractors.length === 0
        ) {
          return;
        }

        setEditLoading(true);
        setEditMode(true);
        setEditId(id);


        const res = await ProjectService.getById(id);
        const proj = res.data;

        if (proj.projectWorkItems && proj.projectWorkItems.length > 0) {

          const items = proj.projectWorkItems.map((w) => ({
            slNo: w.slNo || "",
            isDashboard: Number(w.isDashboard) === 1 || w.isDashboard === true || String(w.isDashboard) === '1',
            workItemId: w.workItemId,
            uom: w.uom,
            quantity: w.quantity,
            isActive: w.isActive === 1
          }));

          // Sort items by slNo before loading into state
          items.sort((a, b) => {
            const aNum = parseFloat(a.slNo) || 0;
            const bNum = parseFloat(b.slNo) || 0;
            if (aNum !== bNum) return aNum - bNum;
            return String(a.slNo || "").localeCompare(String(b.slNo || ""), undefined, { numeric: true, sensitivity: 'base' });
          });

          // setProjectWorkItems(items);
          const renumbered = renumberSlNos(items);

          setProjectWorkItems(renumbered);

        } else {

          setProjectWorkItems([
            { slNo: "", workItemId: "", uom: "", quantity: "", isDashboard: false, isActive: true }
          ]);

        }

        setValue("projectName", proj.projectName);
        setValue("projectCode", proj.projectCode);
        setValue("projectCategoryId", proj.projectCategoryId);
        setValue("itemCategoryId", proj.itemCategoryId);
        setValue("contractorId", proj.contractorId);

        setValue("fromKMS", proj.fromKMS);
        setValue("toKMS", proj.toKMS);
        setValue("totalChainage", proj.totalChainage);
        setTotalChainage(proj.totalChainage);

        setValue(
          "projectStartDate",
          proj.projectStartDate ? proj.projectStartDate.split("T")[0] : ""
        );

        setValue(
          "projectEndDate",
          proj.projectEndDate ? proj.projectEndDate.split("T")[0] : ""
        );

        setValue("projectDescription", proj.projectDescription);
        setValue("projectStatus", proj.projectStatus || "Active");


      } catch (err) {
        console.error("Modify load error:", err);
      }
      finally {
        setEditLoading(false);
      }

    };

    loadEdit();
  }, [id, projectCategories, itemCategories, contractors]);

  useEffect(() => {
    if (!projectStartDate || !projectEndDate) {
      setError(null);
      return;
    }

    if (moment(projectEndDate).isSameOrBefore(projectStartDate)) {
      setError("End date must be after Start date");
    } else {
      setError(null);
    }
  }, [projectStartDate, projectEndDate]);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   clearTimeout(messageTimer.current);
  // };

  const onSubmit = async (formData) => {
    setLoading(true);

    try {
      let res;
      const companyId = StorageService.activeCompany().companyId;

      // const allProjects = await ProjectService.getAllProjects(companyId);

      // const duplicate = allProjects?.find(
      //   (p) =>
      //     p.projecconst workItemsRes = await ProjectWorkItemsService.getByProjectId(id);tName?.toLowerCase() === formData.projectName?.toLowerCase() &&
      //     Number(p.id) !== Number(editId)
      // );

      // if (duplicate) {
      //   showMessage("Duplicate Project Name!", "error");
      //   return;
      // }


      // Validate project work items
      const seenWorkItemIds = new Set();
      for (let i = 0; i < projectWorkItems.length; i++) {
        const item = projectWorkItems[i];
        const rowNum = item.slNo || (i + 1);

        const hasWorkItem = Boolean(item.workItemId && String(item.workItemId).trim());
        const hasUom = Boolean(item.uom && String(item.uom).trim());
        const hasQty = item.quantity !== "" && item.quantity !== null && item.quantity !== undefined;

        if (hasWorkItem || hasUom || hasQty) {
          if (!hasWorkItem) {
            showMessage(`Please select Work Item for row ${rowNum}`, "error");
            setLoading(false);
            return;
          }
          if (!hasUom) {
            showMessage(`Please select UOM for row ${rowNum}`, "error");
            setLoading(false);
            return;
          }
          if (!hasQty || isNaN(Number(item.quantity)) || Number(item.quantity) <= 0) {
            showMessage(`Please enter a valid Quantity for row ${rowNum}`, "error");
            setLoading(false);
            return;
          }
          if (seenWorkItemIds.has(String(item.workItemId))) {
            showMessage(`Duplicate Work Item selected at row ${rowNum}`, "error");
            setLoading(false);
            return;
          }
          seenWorkItemIds.add(String(item.workItemId));
        }
      }

      formData.projectCode = formData.projectCode.toUpperCase();
      formData.projectStatus = formData.projectStatus || "Active";
      formData.isActive = formData.projectStatus === "Active" ? 1 : 0;
      formData.isDelete = 0;
      formData.companyId = StorageService.activeCompany().companyId;
      formData.createdDate = new Date();

      // formData.projectWorkItems = projectWorkItems
      const orderedItems = renumberSlNos(
        [...projectWorkItems].sort((a, b) => {
          const aNum = parseFloat(a.slNo) || 0;
          const bNum = parseFloat(b.slNo) || 0;
          return aNum - bNum;
        })
      );

      formData.projectWorkItems = orderedItems
        .filter(item => item.workItemId && item.uom && item.quantity)
        .sort((a, b) => {
          const aNum = parseFloat(a.slNo) || 0;
          const bNum = parseFloat(b.slNo) || 0;
          if (aNum !== bNum) return aNum - bNum;
          return String(a.slNo || "").localeCompare(String(b.slNo || ""), undefined, { numeric: true, sensitivity: 'base' });
        })
        .map((item) => ({
          slNo: item.slNo || "",
          isDashboard: item.isDashboard ? 1 : 0,
          workItemId: Number(item.workItemId),
          uom: item.uom,
          quantity: Number(item.quantity),
          // status: "Active",
          isActive: item.isActive ? 1 : 0,

          status: item.isActive
            ? "Active"
            : "Inactive",
          createdBy: StorageService.loginData().employeeId,
          createdDate: new Date(),
        }));


      if (editMode) {
        formData.updatedBy = StorageService.loginData().employeeId;
        formData.updatedDate = new Date();

        res = await ProjectService.updateProject(editId, formData);

      } else {
        formData.createdBy = StorageService.loginData().employeeId;
        formData.createdDate = new Date();

        res = await ProjectService.saveProject(formData);

      }

      const isSuccess =
        res?.status ||
        res?.data?.status ||
        res?.status === 200 ||
        res?.status === 201;

      if (isSuccess) {
        showMessage(
          editMode
            ? "Project updated successfully."
            : "Project added successfully.",
          "success"
        );

        setTimeout(() => {
          localStorage.removeItem("editProject");
          navigate("/cpnl/projects/view");
        }, 1000);
      } else {
        showMessage("Failed to save project.", "error");
      }
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    localStorage.removeItem("editProject");
    navigate("/cpnl/projects/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Project" : "Add Project"}
        secondTitle="Masters"
      />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center w-100 mb-2 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
              />
            </div>
          )} */}


          <MessageDialog
            message={message}
            type={msgType}
            setMessage={setMessage}
            setMsgType={setMsgType}
          />




          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Project Name <span className="text-danger">*</span></label>
                  {/* <input
                    type="text"
                    className="form-control"
                    {...register("projectName", { required: "Required" })}
                    disabled={loading}
                  /> */}

                  <input
                    type="text"
                    className="form-control"
                    {...register("projectName", { required: "Project Name is required" })}
                    disabled={loading}
                  />
                  {errors.projectName && (
                    <small className="text-danger">{errors.projectName.message}</small>
                  )}

                </div>

                <div className="col-md-6">
                  <label className="form-label">Project Category <span className="text-danger">*</span></label>
                  {/* <select
                    className="form-select"
                    {...register("projectCategoryId", { required: "Required" })}
                    disabled={loading}
                  >
                    <option value="">Select Category</option>
                    {projectCategories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.categoryName || cat.projectCategoryName || cat.name}
                      </option>
                    ))}
                  </select> */}

                  <select
                    className="form-select"
                    {...register("projectCategoryId", {
                      required: "Project Category is required",
                      onChange: (e) => {
                        const category = projectCategories.find(
                          (c) => String(c.id) === String(e.target.value)
                        );

                        const prefix =
                          category?.categoryCode ||
                          category?.projectCategoryCode ||
                          category?.code ||
                          "";

                        if (prefix) {
                          setValue("projectCode", `${prefix.toUpperCase()}-`);
                        }
                      }
                    })}
                  >

                    {/* <select
                    className="form-select"
                    {...register("projectCategoryId", { required: "Project Category is required" })}
                    disabled={loading}
                  > */}
                    <option value="">Select Category</option>
                    {projectCategories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.categoryName || cat.projectCategoryName || cat.name}
                      </option>
                    ))}
                  </select>
                  {errors.projectCategoryId && (
                    <small className="text-danger">{errors.projectCategoryId.message}</small>
                  )}

                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Code <span className="text-danger">*</span></label>
                  {/* <input
                    type="text"
                    className="form-control"
                    {...register("projectCode", { required: "Required" })}
                    onChange={(e) =>
                      setValue("projectCode", e.target.value.toUpperCase())
                    }
                    disabled={loading}
                  /> */}

                  <input
                    type="text"
                    className="form-control"
                    {...register("projectCode", { required: "Project Code is required" })}
                    onChange={(e) =>
                      setValue("projectCode", e.target.value.toUpperCase())
                    }
                    disabled={loading}
                  />
                  {errors.projectCode && (
                    <small className="text-danger">{errors.projectCode.message}</small>
                  )}

                </div>
                {/* 
                <div className="col-md-6">
                  <label className="form-label">Item Category <span className="text-danger">*</span></label>
                  <select
                    className="form-select"
                    {...register("itemCategoryId", { required: "Required" })}
                    disabled={loading}
                  >
                    <option value="">Select Item Category</option>
                    {itemCategories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.itemCategoryName || cat.itemName || cat.name}
                      </option>
                    ))}
                  </select>
                </div> */}
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Start Date <span className="text-danger">*</span></label>
                  {/* <input type="date"
                    className="form-control"
                    {...register("projectStartDate", { required: "Required" })}
                  /> */}

                  <input
                    type="date"
                    className="form-control"
                    {...register("projectStartDate", { required: "Start Date is required" })}
                  />
                  {errors.projectStartDate && (
                    <small className="text-danger">{errors.projectStartDate.message}</small>
                  )}

                </div>

                <div className="col-md-6">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control" onChange={(e) => setToDate(e.target.value)}
                    {...register("projectEndDate")}
                  />
                  {error && (
                    <small className="text-danger">{error}</small>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">Start Ch <span className="text-danger">*</span></label>


                  {/* <input
                    type="number"
                    step="0.001"
                    min="0"
                    className="form-control"
                    {...register("fromKMS", {
                      required: "Start Ch is required",
                      pattern: {
                        value: /^\d+(\.\d{0,3})?$/,
                        message: "Maximum 3 decimal places allowed",
                      },
                    })}
                  /> */}
                  <input
                    type="number"
                    step="0.001"
                    min="0"
                    className="form-control"
                    {...register("fromKMS", {
                      required: "Start Ch is required",
                      pattern: {
                        value: /^\d+(\.\d{0,3})?$/,
                        message: "Maximum 3 decimal places allowed",
                      },
                    })}
                    onBlur={(e) => {
                      let value = e.target.value;
                      if (value !== "") {
                        value = parseFloat(value).toFixed(3); // ✅ convert to 3 decimals
                        setValue("fromKMS", value);
                      }
                    }}
                  />

                  {errors.fromKMS && (
                    <small className="text-danger">{errors.fromKMS.message}</small>
                  )}

                </div>

                <div className="col-md-4">
                  <label className="form-label">End Ch </label>


                  {/* <input
                    type="number"
                    step="0.001"
                    min="0"
                    className="form-control"
                    {...register("toKMS", {
                      required: "End Ch is required",
                      pattern: {
                        value: /^\d+(\.\d{0,3})?$/,
                        message: "Maximum 3 decimal places allowed",
                      },
                    })}
                  /> */}

                  <input
                    type="number"
                    step="0.001"
                    min="0"
                    className="form-control"
                    {...register("toKMS", {
                      required: "End Ch is required",
                      pattern: {
                        value: /^\d+(\.\d{0,3})?$/,
                        message: "Maximum 3 decimal places allowed",
                      },
                    })}
                    onBlur={(e) => {
                      let value = e.target.value;
                      if (value !== "") {
                        value = parseFloat(value).toFixed(3); // ✅ convert to 3 decimals
                        setValue("toKMS", value);
                      }
                    }}
                  />

                  {errors.toKMS && (
                    <small className="text-danger">{errors.toKMS.message}</small>
                  )}

                </div>

                <div className="col-md-4">
                  <label className="form-label">Total Ch (KM)</label>
                  {/* <input
                    type="number"
                    step="any"
                    min="0"
                    className="form-control"
                    {...register("totalChainage", { required: "Required", valueAsNumber: true, })}

                  /> */}

                  <input
                    type="number"
                    step="0.001"
                    min="0"
                    readOnly
                    className="form-control"
                    {...register("totalChainage", {
                      required: "Total Chainage is required",
                      pattern: {
                        value: /^\d+(\.\d{0,3})?$/,
                        message: "Maximum 3 decimal places allowed",
                      },
                    })}
                  />

                  {errors.totalChainage && (
                    <small className="text-danger">{errors.totalChainage.message}</small>
                  )}

                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Primary Contractor <span className="text-danger">*</span></label>
                  <select
                    className="form-select"
                    {...register("contractorId", { required: " Contractor Required" })}
                  >
                    <option value="">Select Contractor</option>
                    {contractors.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.contractorName}
                      </option>
                    ))}
                  </select>
                  {errors.contractorId && (
                    <small className="text-danger">
                      {errors.contractorId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">Project Description</label>
                  <textarea
                    className="form-control"
                    {...register("projectDescription")}
                  ></textarea>
                </div>
              </div>

              <hr />

              <div className="card mt-4 py-2 bg-white shadow-sm">

                <h5>Project Work Items</h5>

                <table className="table table-bordered mt-2">
                  <thead>
                    <tr>
                      <th style={{ width: '70px' }}>Sl. No</th>
                      <th style={{ width: '220px' }}>Work Item</th>
                      <th style={{ width: '220px' }}>UOM</th>
                      <th style={{ width: '140px' }}>Quantity</th>
                      <th style={{ width: '60px' }}>DPR Active</th>
                      <th style={{ width: '60px' }}>Dashboard</th>
                      <th style={{ width: '90px' }}>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {projectWorkItems.map((row, index) => (
                      <tr key={index}>

                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.slNo || ""}
                            placeholder="Sl. No"
                            onChange={(e) =>
                              handleWorkItemChange(index, "slNo", e.target.value)
                            }
                          />
                        </td>

                        <td>
                          <select
                            className="form-select"
                            value={row.workItemId}
                            disabled={!selectedCategoryId}
                            onChange={(e) =>
                              handleWorkItemChange(index, "workItemId", e.target.value)
                            }
                          >
                            <option value="">
                              {selectedCategoryId ? "Select Work Item" : "Select Project Category First"}
                            </option>

                            {filteredWorkItemsList.map((w) => (
                              <option key={w.id} value={w.id}>
                                {w.workItemCode}
                              </option>
                            ))}

                          </select>
                        </td>

                        <td>
                          <select
                            className="form-select"
                            value={row.uom}
                            onChange={(e) =>
                              handleWorkItemChange(index, "uom", e.target.value)
                            }
                          >
                            <option value="">Select UOM</option>

                            {uoms.map((u) => (
                              <option key={u.id} value={u.uomCode}>
                                {u.uomCode} - {u.description}
                              </option>
                            ))}

                          </select>
                        </td>

                        <td>
                          <input
                            type="number"
                            step="0.001"
                            min="0"
                            className="form-control"
                            value={row.quantity}
                            placeholder="Quantity"
                            onChange={(e) =>
                              handleWorkItemChange(index, "quantity", e.target.value)
                            }
                            onBlur={(e) => {
                              let value = e.target.value;

                              if (value !== "") {
                                value = parseFloat(value).toFixed(3);

                                handleWorkItemChange(index, "quantity", value);
                              }
                            }}
                          />
                        </td>

                        {/* <td className="text-center">
                          <input
                            type="checkbox"
                            checked={row.isActive}
                            onChange={(e) =>
                              handleWorkItemChange(
                                index,
                                "isActive",
                                e.target.checked
                              )
                            }
                          />
                        </td> */}

                        <td>
  <div className="form-check form-switch d-flex justify-content-center align-items-center">
    <input
      className="form-check-input"
      type="checkbox"
      id={`isActive_${index}`}
      checked={row.isActive || false}
      onChange={(e) =>
        handleWorkItemChange(
          index,
          "isActive",
          e.target.checked
        )
      }
    />

    <label
      className="form-check-label"
      htmlFor={`isActive_${index}`}
    ></label>
  </div>
</td>



                        <td >
                          <div className="form-check form-switch d-flex justify-content-center align-items-center">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`isDashboard_${index}`}
                              checked={row.isDashboard || false}
                              onChange={(e) =>
                                handleWorkItemChange(
                                  index,
                                  "isDashboard",
                                  e.target.checked
                                )
                              }
                            />

                            <label
                              className="form-check-label"
                              htmlFor={`isDashboard_${index}`}
                            >

                            </label>
                          </div>
                        </td>

                        <td className="text-center">

                          {index === projectWorkItems.length - 1 && (
                            <button
                              type="button"
                              className="btn btn-success btn-sm me-2"
                              onClick={handleAddRow}
                            >
                              +
                            </button>
                          )}

                          {projectWorkItems.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDeleteRow(index)}
                            >
                              -
                            </button>
                          )}

                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div>
                <button
                  className="btn btn-primary me-2"
                  type="submit"
                  disabled={loading}
                >
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? editMode
                      ? "Updating..."
                      : "Saving..."
                    : editMode
                      ? "Update"
                      : "Save"}
                </button>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={handleCancel}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}

        </div>

      </div>
    </>
  );
}
